import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { AccountSettingService } from '@features/auth/core/domain/account/account-setting.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { ToastrService } from '@shared/components/lib-ngx/ngx-toastr/toastr/toastr.service';
import _ from 'lodash';
import { RECOVERY_EMAIL_HUTECH_CONST } from './const';
import { ResetPasswordEmailModel } from '@features/auth/core/domain/account/model/reset-password-email.model';
import { CountdownTimerComponent } from './shared/countdown-timer.component';
@Component({
  standalone: true,
  imports: [
    CommonModule,
    CountdownTimerComponent
  ],
  selector: 'app-reset-password-email-hutech',
  templateUrl: 'reset-password-email-hutech.component.html',
  styleUrls: ['reset-password-email-hutech.component.scss'],
})
export class ResetPasswordEmailHUTECHComponent implements OnInit, OnDestroy {
  private accountSettingService = inject(AccountSettingService);

  private toast = inject(ToastrService);
  

  readonly _RECOVERY_EMAIL_HUTECH_CONST = RECOVERY_EMAIL_HUTECH_CONST;

  // View states
  isInitialLoading = true;
  hasEmailFeature = true;
  isSubmitting = false;
  isExpired = false;
  // Request states
  emailRecoveryHUTECH: ResetPasswordEmailModel = new ResetPasswordEmailModel(null);

  // Account information
  emailSupport = 'hotrosinhvien@hutech.edu.vn';
  phoneSupport = '028 3512 0785';
  boPhanSupport = 'TRUNG TÂM HỖ TRỢ SINH VIÊN';

  private destroy$ = new Subject<void>();

  constructor() {}

  ngOnInit() {
    this.loadEmailInfo();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Load email information from API
   */
  loadEmailInfo() {
    this.isInitialLoading = true;

    this.accountSettingService
      .getRecoveryEmailHUTECH()
      .pipe(
        takeUntil(this.destroy$),
      )
      .subscribe({
        next: (response: ResetPasswordEmailModel) => {
          this.emailRecoveryHUTECH = response;
          console.log('=== Load email info response', response);
          // Check if user has email HUTECH
          console.log('=== !_.isEmpty(response.email?.trim())', !_.isEmpty(response.email));
          this.hasEmailFeature = !_.isEmpty(response.email);
          this.isInitialLoading = false;
        },
        error: (error) => {
          this.hasEmailFeature = false;
          this.isInitialLoading = false;
          this.toast.error(error?.desc?.message || 'Không thể tải thông tin email. Vui lòng thử lại.');
        },
      });
  }

  /**
   * Handle sending recovery request
   */
  handleRequestRecovery() {
    if (!this.emailRecoveryHUTECH.email) {
      this.isExpired = true;
      this.toast.error('Không tìm thấy email HUTECH.');
      return;
    }
    this.isExpired = true;
    this.isSubmitting = true;
    this.accountSettingService
      .resetPasswordEmailHUTECH()
      .pipe(
        takeUntil(this.destroy$),
      )
      .subscribe({
        next: (response) => {
          this.emailRecoveryHUTECH = response;
          if (this.hasEmailFeature) {
            this.toast.success('Yêu cầu khôi phục mật khẩu đã được gửi thành công. Vui lòng kiểm tra email khôi phục của bạn.');
          }
          this.isSubmitting = false;
        },
        error: (error) => {
          // this.hasEmailFeature = false;
          this.isSubmitting = false;
          // Handle specific error messages from API
          const errorMessage = error?.desc?.message || 'Không thể gửi yêu cầu khôi phục. Vui lòng thử lại sau.';
          this.toast.error(errorMessage);
        },
      });
  }

  /**
   * Format seconds to MM:SS
   */
  // formatTime(seconds: number): string {
  //   const mins = Math.floor(seconds / 60);
  //   const secs = seconds % 60;
  //   return `${mins}:${secs.toString().padStart(2, '0')}`;
  // }

  /**
   * Copy password to clipboard
   */
  copyToClipboard() {
    if (this.emailRecoveryHUTECH.requestInfo.passText) {
      navigator.clipboard.writeText(this.emailRecoveryHUTECH.requestInfo.passText).then(
        () => {
          this.toast.success('Đã sao chép mật khẩu vào clipboard');
        },
        (err) => {
          console.error('Could not copy password:', err);
        }
      );
    }
  }

  /**
   * Reload email info (for "Kiểm tra lại" button)
   */
  reloadEmailInfo() {
    this.loadEmailInfo();
  }

  onCountdownExpired() {
    this.isExpired = true;
  }

}
